import cnh from '~/helpers/cnh';
import { dateToString } from '~/helpers/dateToString';
import { DayState } from '~/hooks/calendar/useDayStateForDate';
import { useOptions } from '~/hooks/useOptions';
import useTranslation from '~/hooks/useTranslation';
import buttonStyles from '~/styles/button.module.css';
import { InferredCalendarOptions } from '~/types/options';

type Props = {
  selectedDayState: DayState;
  pax: number;
  packageId: number;
};

function generateBookingUrl(
  bookingUrl: string,
  packageId: number,
  date: string,
  pax: number,
) {
  return bookingUrl
    .replace('[date]', date)
    .replace('%5Bdate%5D', date)
    .replace('[pax]', pax.toString())
    .replace('%5Bpax%5D', pax.toString())
    .replace('[package]', packageId.toString())
    .replace('%5Bpackage%5D', packageId.toString());
}

export default function BookingButton({
  selectedDayState,
  pax,
  packageId,
}: Props) {
  const options = useOptions() as InferredCalendarOptions;
  const translate = useTranslation();

  const bookingUrl = generateBookingUrl(
    options.bookingUrl,
    packageId,
    dateToString(selectedDayState.date),
    pax,
  );

  return (
    <a
      href={bookingUrl}
      className={cnh(buttonStyles.btn, buttonStyles.btnPrimary, buttonStyles.btnFull)}
      aria-disabled={!bookingUrl}
      data-testid="booking-button"
    >
      {translate('calendar.book_now')}
    </a>
  );
}
